import { SearchParams } from "app/singing/vocal-driller/usePlayer/getDefaultExternalState";

export const apiPostSingingPracticeGetShortLinkPath = `/api/singing-practice/get-short-link`;
export type ApiPostSingingPracticeGetShortLinkResponse = { short_link: string };
export type ApiPostSingingPracticeGetShortLinkParams =
  Required<SearchParams> & { slug: string };
